import { useGetNoticesFromNewspaperMutation } from '@frontend/redux';
import { PAGE_TITLES } from '@frontend/common';

import withNoticeList from './withNoticeList';

const NewspaperNotices = withNoticeList(
  useGetNoticesFromNewspaperMutation
);

export default NewspaperNotices;